import BaseService from "./base.service";

class DashboardService extends BaseService {
  get entity() {
    return "dashboard";
  }

  getPerformanceByTopics(courseId, mockLogId) {
    let url;
    if (courseId) {
      url = `${this.entity}/performance-by-topics?courseId=${courseId}`;
    }
    if (mockLogId) {
      url = `${this.entity}/performance-by-topics?mockLogId=${mockLogId}`;
    }
    return new Promise((resolve, reject) => {
      return this.request()
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getQuestionSolved(type, dateRange) {
    let url;
    if (type !== null) {
      url = `${this.entity}/questions-solved?type=${type}&dateRange=${dateRange}`;
    } else {
      url = `${this.entity}/questions-solved?dateRange=${dateRange}`;
    }
    return new Promise((resolve, reject) => {
      return this.request()
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getBestScore(dateRange) {
    const url = `${this.entity}/best-score?dateRange=${dateRange}`;
    return new Promise((resolve, reject) => {
      return this.request()
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getItemsWatchedByRange(dateRange) {
    const url = `${this.entity}/items-watched?dateRange=${dateRange}`;
    return new Promise((resolve, reject) => {
      return this.request()
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}

export default new DashboardService();
